<template>
    <div class="copySubmitBar clearfix"
        v-if="currentPageSelect.length > 1"
    >
        <div class="copy-left fl">
            {{$t('selected')}}{{currentPageSelect.length}}{{$t('item')}}
        </div>
        <div class="copy-right fr">
            <el-button size="small" @click="submitEditCopyHandle" type="primary">{{$t('Edit_subscription')}}</el-button>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'copySubmitBar',
    props: {
      currentPageSelect: {
        type: Array,
        default(){
          return [];
        }
      },
    },
    computed: {
      ...mapGetters([]),
    },
    methods: {
      submitEditCopyHandle() {
        this.$store.commit('setMasterAccountEditSubscrpitDialogType', 'mam');
        this.$store.commit('setCopyingSelectMultiple', true);

        let defaultEditSubscrpitParams = {
          copyType: 1,
          copyValue: '',
          copyMaxNum: '',
          copyMaxLots: '',
          copyStatus: 1,
          isRenew: 1,
        };
        this.$store.commit('setMasterAccountEditSubscrpitParams', defaultEditSubscrpitParams);
        this.$store.commit('setCopyingSelectData', this.currentPageSelect);

        this.$store.commit('setCurrentMasterMtId', +this.$route.params.mtid);
        this.$store.commit('setMasterAccountEditSubscrpitDialogShow', true);
      }
    }
  };
</script>

<style lang="scss" scoped>
    .copySubmitBar {
        width: 100%;
        bottom: 0;
        left: 0;
        font-size: 14px;
        color: #333333;

        padding-left: 30px;
        padding-right: 30px;
        .copy-left {
            height: 100%;
            .link {
                margin-right: 20px;
            }
        }
        .copy-right {
            margin-right: 20px;
        }
    }
    @media screen and (min-width: 768px){
        .copySubmitBar {
            position: fixed;
            height: 50px;
            line-height: 50px;
            background-color: #ffffff;
        }
    }
    @media screen and (max-width: 768px){
        .copySubmitBar {
            padding: 10px;
            .link {
                display: inline-block;
                margin-bottom: 10px;
            }
        }
        .copySubmitBar .copy-right {
            float: left;
        }
    }
</style>
